import React from 'react'
import Actions from './Actions'
import ChartTypes from './ChartTypes'
import OppPositions from './OppPositions'
import Positions from './Positions'
import StackSizes from './StackSizes'

const ChartOptions = ({
  selectedFilters,
  setSelectedFilters,
  config,
  filterMocks,
  actions,
  opponents,
  userAccess,
  positions,
  stackSizes,
  setShowAccessPopup
}) => {
  return (
    <div style={{display: 'flex', flexDirection: 'column', rowGap: '8px', marginTop: '5px'}}>
      <ChartTypes
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <StackSizes
        stackSizes={stackSizes}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        config={config}
        userAccess={userAccess}
        showAccessPopup={() => setShowAccessPopup(true)}
      />
      <Positions
        positions={positions}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <Actions
        actionsMock={filterMocks.vsActions}
        actions={actions}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
      <OppPositions
        oppPositionsMock={filterMocks.oppPositions}
        opponents={opponents}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
      />
    </div>
  )
}

export default ChartOptions
